const csrfToken = function () {
  const token = document.head.querySelector(
    '[name~=csrf-token][content]'
  )
  return token && token.content
}

export default csrfToken
